import React, { useEffect, useRef, useState } from 'react'

import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";



const Services = ({ data, tipo }) => {
    const [cardsPerSlide, setCardsPerSlide] = useState(4);
    const [isBeginning, setIsBeginning] = useState(true); // Estado para el inicio del carrusel
    const [isEnd, setIsEnd] = useState(false); // Estado para el final del carrusel
    const swiperRef = useRef(null);

    // Detectar cuántas tarjetas mostrar según el ancho de la pantalla
    useEffect(() => {
        const updateCardsPerSlide = () => {
            let newCount;
            if (window.innerWidth < 576) {
                newCount = 1;
            } else if (window.innerWidth < 900) {
                newCount = 2;
            } else if (window.innerWidth < 1300) {
                newCount = 3;
            } else {
                newCount = 4;
            }
            setCardsPerSlide(newCount);
        };

        updateCardsPerSlide();
        window.addEventListener("resize", updateCardsPerSlide);
        return () => window.removeEventListener("resize", updateCardsPerSlide);
    }, []);

    return (
        <div>
            <section className='data'>
                <div className='data__header'>
                    {tipo === "productos" && (
                        <>
                            <h1 className='data__title'>Productos</h1>
                            <p className='data__description'>Productos ipsum dolor sit amet, consectetur adipiscing elit. Praesent purus libero, scelerisque eu metus eget, sollicitudin hendrerit eros.
                                Aliquam in viverra leo. Integer accumsan tempus nisl, eu varius mi finibus eget. Morbi elit mi, tristique in lorem id, volutpat vulputate turpis.
                                Aliquam non erat faucibus, ornare arcu in, tempor quam. Quis
                            </p>
                        </>
                    )}
                    {tipo === "proyectos" && (
                        <>
                            <h1 className='data__title'>Proyectos</h1>
                            <p className='data__description'>Proyectos ipsum dolor sdfsit amet, consectetur adipiscing elit. Praesent purus libero, scelerisque eu metus eget, sollicitudin hendrerit eros.
                                Aliquam in viverra leo. Integer accumsan tempus nisl, eu varius mi finibus eget. Morbi elit mi, tristique in lorem id, volutpat vulputate turpis.
                                Aliquam non erat faucibus, ornare arcu in, tempor quam. Quis
                            </p>
                        </>
                    )}
                    {tipo === "servicios" && (
                        <>
                            <h1 className='data__title'>Services</h1>
                            <p className='data__description'>Services ipsum dolor sit amet, consectetur adipiscing elit. Praesent purus libero, scelerisque eu metus eget, sollicitudin hendrerit eros.
                                Aliquam in viverra leo. Integer accumsan tempus nisl, eu varius mi finibus eget. Morbi elit mi, tristique in lorem id, volutpat vulputate turpis.
                                Aliquam non erat faucibus, ornare arcu in, tempor quam. Quis
                            </p>
                        </>
                    )}

                </div>
                <div className='data__carrusel'>
                    <div className='data__buttons'>
                        <button
                            className={`data-swiper-button-prev ${isBeginning ? "disabled" : ""}`}
                            onClick={() => swiperRef.current?.slidePrev()}
                            disabled={isBeginning}
                        ></button>
                        <button
                            className={`data-swiper-button-next ${isEnd ? "disabled" : ""}`}
                            onClick={() => swiperRef.current?.slideNext()}
                            disabled={isEnd}
                        ></button>
                    </div>
                    <Swiper
                        key={cardsPerSlide}
                        modules={[Navigation, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={cardsPerSlide}
                        autoplay={{ delay: 30000, disableOnInteraction: false }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                            setIsBeginning(swiper.isBeginning);
                            setIsEnd(swiper.isEnd);
                        }}
                        onSlideChange={(swiper) => {
                            setIsBeginning(swiper.isBeginning);
                            setIsEnd(swiper.isEnd);
                        }}
                    >
                        {data.map((item) => (
                            <SwiperSlide key={item.id} >
                                <div className="data-card">
                                    <div className='data-card__icon' >
                                        <img className='data-card__image'
                                            src={item.icono}
                                            alt={item.title}
                                        />
                                    </div>
                                    <div className="data-card__content">
                                        <h3 className="data-card__title">{item.title}</h3>
                                        <p className="data-card__description">{item.description}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </div>
    )
}

export default Services;
